module.exports = __webpack_public_path__ + "img/pan.35e3fe56.jpg";